<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Position Column -->
    <ng-container matColumnDef="variable">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let element"> {{element.variable}} </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="stabili">
      <th mat-header-cell *matHeaderCellDef> STABILI </th>
      <td mat-cell *matCellDef="let element"> {{element.stabili}} </td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="miglioramento">
      <th mat-header-cell *matHeaderCellDef> MIGLIORAMENTO </th>
      <td mat-cell *matCellDef="let element"> {{element.miglioramento}} </td>
    </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="peggioramento">
            <th mat-header-cell *matHeaderCellDef> PEGGIORAMENTO </th>
            <td mat-cell *matCellDef="let element"> {{element.peggioramento}} </td>
          </ng-container>

  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>